import { render, staticRenderFns } from "./WelcomeToMortgageWatch.vue?vue&type=template&id=0ba24904&"
import script from "./WelcomeToMortgageWatch.vue?vue&type=script&lang=js&"
export * from "./WelcomeToMortgageWatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports